import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// modals with draggable and resize
import { vfmPlugin } from "vue-final-modal";

import moment from "moment";
import formatDatePlugin from "@/plugins/format-date-plugin.js";

// custom components
import LocalizedLink from "@/components/LocalizedLink.vue";
import BaseModal from "@/components/BaseModal.vue";

// i18n localize
import i18n from "./plugins/i18n.js";

// element ui library
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";

// Phone MASK input
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import "./assets/scss/chanel.scss"; // custom styles

const app = createApp(App);

moment.locale("en");
app.config.globalProperties.$moment = moment;

// use modals
app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.component("localized-link", LocalizedLink);
app.component("base-modal", BaseModal);

app
  .use(VueTelInput)
  .use(store)
  .use(ElementPlus)
  .use(router)
  .use(i18n)
  .use(formatDatePlugin);

app.mount("#app");
